import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';
import { createRemitSettings } from '../api/remit-settings.ts';
import { RemitSetting } from '../models/remit-setting.ts';

export default function useCreateRemitSetting(): UseMutationResult<
  string,
  Error,
  RemitSetting
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request: RemitSetting) => createRemitSettings(request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['remitSettings'] });
    },
  });
}
